module.exports = __webpack_public_path__ + "static/media/visa.bec98b8d.svg";